import AED from './AED';
import BHD from './BHD';
import ILS from './ILS';
import JOD from './JOD';
import KWD from './KWD';
import LBP from './LBP';
import OMR from './OMR';
import QAR from './QAR';
import SAR from './SAR';
import YER from './YER';

export const MIDDLE_EAST_CURRENCIES = {
    [AED.codeNumeric]: AED,
    [BHD.codeNumeric]: BHD,
    [ILS.codeNumeric]: ILS,
    [JOD.codeNumeric]: JOD,
    [KWD.codeNumeric]: KWD,
    [LBP.codeNumeric]: LBP,
    [OMR.codeNumeric]: OMR,
    [QAR.codeNumeric]: QAR,
    [SAR.codeNumeric]: SAR,
    [YER.codeNumeric]: YER
};
